export default "__VITE_ASSET__C6MaE8gb__"